var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-278 370 54 54",
    style: {
      enableBackground: "new -278 370 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n\t.st1{fill:#298BC1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-244.9,405.1c0,1.7,1,2.6,2.4,2.9v-4.7c-0.2-0.1-0.4-0.2-0.7-0.2c-2.3-0.5-4.5-1.5-4.5-4.4 c0-3,2.5-4.6,5.2-4.7v-1.7h1.3v1.7c2.6,0.2,4.8,1.6,5,4.7h-3.2c0-1.2-0.9-2.2-1.9-2.2v4c0.4,0.1,0.7,0.2,1.2,0.3 c4.3,1.2,4.4,3.6,4.4,5.2c0,1.2-1.2,4.3-5.6,4.7v1.9h-1.3v-1.9c-3.3-0.2-5.2-2-5.6-5.6H-244.9z M-242.6,396.5c-1,0-2,0.6-2,1.9 c0,1,0.5,1.5,2,1.8V396.5z M-241.3,408c1.1-0.1,2.4-0.8,2.4-2.2c0-1.2-0.6-1.6-2.4-2.1V408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-236.3,377.5h-28.9l3.1,3.2h25.8c1.7,0,3,1.4,3,3v28.2c0,1.7-1.4,3-3,3h-29.5c-1.7,0-3-1.4-3-3v-25.6 l-3.1-3.3l-0.1,28.9c0,3.4,2.8,6.2,6.2,6.2h29.5c3.4,0,6.2-2.8,6.2-6.2v-28.1C-230.1,380.4-232.8,377.5-236.3,377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.1,394.9c-0.5,0-5.1-0.1-5.1-0.1c-1.2,0-2.1,0.9-2,2c0,1.1,0.9,1.9,2,1.9c3.3,0,6.7,0.1,10,0.1l0,0 c1.1,0,1.9-0.7,2-1.9c0.1-3.3,0.1-6.7,0.1-9.9c0-1.1-1-1.9-1.9-1.9h-0.1c-1.1,0.1-1.9,0.9-1.9,2.1c0,1.2-0.1,5-0.1,5 s-14.1-14.6-14.4-14.8c-1,0.9-1.9,1.8-2.9,2.8C-271.4,380.3-259.4,392.6-257.1,394.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.22bd3be41954e53203ef955d152a5905.svg";
export { ForwardRef as ReactComponent };